import { forwardRef } from 'react'

import Body from '~/components/typography/Body'

const Checkbox = forwardRef(
  (
    {
      label,
      description,
      id,
      className = 'focus:ring-highlight h-24 w-24 text-primary border-body-light rounded',
      wrapperClassName = 'relative flex items-start my-32',
      labelClassName = 'font-bold text-body',
      descriptionClassName = 'text-body-alt',
      error,
      ...props
    },
    ref
  ) => (
    <div className="flex flex-col my-32">
      <div className="relative flex items-start ">
        <div className="flex items-center">
          <input
            ref={ref}
            id={id}
            aria-describedby={description ? `${id}-description` : null}
            name={id}
            type="checkbox"
            className={className}
            {...props}
          />
        </div>
        <div className="ml-8 text-sm">
          <Body as="label" htmlFor={id} className={labelClassName}>
            {label}
          </Body>
          {description && (
            <Body
              as="p"
              id={`${id}-description`}
              className={descriptionClassName}
            >
              {description}
            </Body>
          )}
        </div>
      </div>
      {error && (
        <div className="mt-10">
          {error.map((msg) => (
            <p className="text-sm-fluid text-negative mb-5" key={msg}>
              {msg}
            </p>
          ))}
        </div>
      )}
    </div>
  )
)

Checkbox.displayName = 'Checkbox'

export default Checkbox
